<template>
	<div class="toper">
		<div class="left">
			<span>科飞视觉</span>运营管理系统
		</div>
		<div class="right">
			<div class="admin"><i class="el-icon-user-solid" style="margin-right: 5px;"></i>{{ authInfo.uname }}</div>
			<el-button size="mini" type="danger" style="position: relative;margin-left: 15px;" @click="exitSystem">退出系统</el-button>
		</div>
	</div>
</template>

<script>
	import { mapState } from "vuex"
	
	export default {
		computed: {
			...mapState([
				'authInfo'
			])
		},
		methods: {
			exitSystem () {
				const that = this;
				// this.$router.replace({
				// 	path: "/index"
				// });
				this.$confirm(
					'此操作将退出该系统，是否继续?', 
					'提示', 
					{
						type: 'warning'
					}
				).then(
					() => {
						// window.close();
						that.$router.replace({
							path: "/index"
						});
					}
				).catch(
					() => {}
				);
			}
		}
	}
</script>

<style>
	.operation_manage_page .toper{ display: block;position: absolute;z-index: 99;width: 100%;height: 50px;top: 0;left: 0;padding: 0 15px;background: #222; }
	.operation_manage_page .toper .left{ display: block;float: left;font-size: 16px;color: #fff;line-height: 50px; }
	.operation_manage_page .toper .left span{ color: #30a5ff; }
	.operation_manage_page .toper .right{ display: block;float: right;padding: 11px 0 0 0;font-size: 0; }
	.operation_manage_page .toper .right .admin{ display: inline-block;position: relative;font-size: 16px;color: #fff;line-height: 28px;vertical-align: top; }
</style>
